import { Button, Spinner } from 'avo-ui'
import icEdit from 'assets/images/ic-edit.svg'
import { FormAddress } from 'components/user/user-detail/tab-address/FormAddress'

export const TabAddress = ({
    dataAddress,
    modalEdit,
    onShowModalEdit,
    onHide,
    formValue,
    onChangeForm,
    errorForm,
    onSubmit,
    addressOptions,
    onSearchAddress,
    isLoading,
    isLoadingList,
}) => {
    return (
        <div>
            {isLoadingList ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <>
                    <div className={'flex flex-col space-y-8 px-9 py-4'}>
                        {dataAddress?.map((item, index) => (
                            <div key={index} className={'flex flex-col w-full border rounded-lg overflow-hidden'}>
                                <div className={'flex items-center px-5 py-2 justify-between border-b bg-blue-5'}>
                                    <div className={'flex space-x-10 items-center'}>
                                        <p className={'text-lg font-bold text-primary-100 capitalize'}>
                                            Alamat {item?.title}
                                        </p>
                                        {item?.is_main_address && (
                                            <div
                                                className={
                                                    'w-fit px-3 py-1 bg-blue-30 text-primary-100 font-bold rounded-md'
                                                }
                                            >
                                                Alamat Utama
                                            </div>
                                        )}
                                    </div>
                                    <Button
                                        className={'w-fit'}
                                        title={'EDIT ADDRESS'}
                                        icon={icEdit}
                                        onClick={() => onShowModalEdit(item)}
                                    />
                                </div>
                                <div className={'grid grid-cols-2 gap-x-5 p-5'}>
                                    <div className={'flex flex-col space-y-4'}>
                                        <div className={'flex space-x-5'}>
                                            <p className={'text-neutral-60 w-36'}>Nama Penerima</p>
                                            <p className={'text-neutral-90 capitalize'}>{item?.name}</p>
                                        </div>
                                        <div className={'flex space-x-5'}>
                                            <p className={'text-neutral-60 w-36'}>Telp. Penerima</p>
                                            <p className={'text-neutral-90'}>{item?.phone_number}</p>
                                        </div>
                                        <div className={'flex space-x-5'}>
                                            <p className={'text-neutral-60 w-36'}>Kecamatan</p>
                                            <p className={'text-neutral-90'}>{item?.district}</p>
                                        </div>
                                        <div className={'flex space-x-5'}>
                                            <p className={'text-neutral-60 w-36'}>Kabupaten</p>
                                            <p className={'text-neutral-90'}>{item?.city}</p>
                                        </div>
                                        <div className={'flex space-x-5'}>
                                            <p className={'text-neutral-60 w-36'}>Provinsi</p>
                                            <p className={'text-neutral-90'}>{item?.province}</p>
                                        </div>
                                        <div className={'flex space-x-5'}>
                                            <p className={'text-neutral-60 w-36'}>Kode Pos</p>
                                            <p className={'text-neutral-90'}>{item?.zipcode}</p>
                                        </div>
                                    </div>
                                    <div className={'flex flex-col space-y-4'}>
                                        <div className={'flex space-x-5'}>
                                            <p className={'text-neutral-60 w-36'}>Alamat Lengkap</p>
                                            <p className={'text-neutral-90'}>{item?.address}</p>
                                        </div>
                                        <div className={'flex space-x-5'}>
                                            <p className={'text-neutral-60 w-36'}>Catatan</p>
                                            <p className={'text-neutral-90'}>{item?.note}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    {modalEdit && (
                        <FormAddress
                            onSearchAddress={onSearchAddress}
                            addressOptions={addressOptions}
                            show={modalEdit}
                            onHide={onHide}
                            isLoading={isLoading}
                            value={formValue}
                            onChangeForm={onChangeForm}
                            errorForm={errorForm}
                            onSubmit={onSubmit}
                        />
                    )}
                </>
            )}
        </div>
    )
}
